import React from "react";
import RoleDashboardStats from "./statistics/RoleDashboardStats";

const OrganizationUsersStats = () => <RoleDashboardStats />;

export default OrganizationUsersStats;
